import DiscoKids from "../../assets/images/disco_dance_dla_dzieci-1.jpg"
import Akrobatyka from "../../assets/images/akrobatyka.jpg"
import Bachata_solo from "../../assets/images/bachata_solo.jpg"
import CustomButtons from "../Elements/Buttons/customButton"
import { useState, useEffect } from 'react';
const Courses = (props) => {
    useEffect(()=>{
        props.setHeader('/  KURSY');
    },[])
    return (
        <div className="dashboard__content">
            <main>
                <div className="courseWrapper marginTopResponse">
                <p className="forAllH4Tittle">Kursy które mogą cię zainteresowć</p>
                </div>
                <div className="courseWrapper">
                
                    <div  className="courseWrapper_row marginCourse">
                    
                   <div className="courseBoxCenter">
                        <div className="courseBox2">    
                                <img
                                                src={DiscoKids}
                                                alt="Disco Dance dla Dzieci"
                                                className="course__image"
                                            />
                                <a target="_blank"  href="http://egurrola.com/style-taneczne/disco-dance-dla-dzieci/" className="dance-style-box" >
                            
                                    <span className="dance-style-box__name">Disco Dance dla Dzieci</span>
                                </a>
                        </div>
                    </div>
                           
                    <div className="courseBoxCenter">
                        <div className="courseBox2">    
                                <img
                                                src={Akrobatyka}
                                                alt="Akrobatyka"
                                                className="course__image"
                                            />
                                <a target="_blank"  href="http://egurrola.com/style-taneczne/akrobatyka/" className="dance-style-box" >
                            
                                    <span className="dance-style-box__name">Akrobatyka</span>
                                </a>
                        </div>
                    </div>
                           
                    <div className="courseBoxCenter">
                        <div className="courseBox2">    
                                <img
                                                src={Bachata_solo}
                                                alt="Bachata_solo"
                                                className="course__image"
                                            />
                                <a target="_blank"  href="http://egurrola.com/style-taneczne/bachata-solo/" className="dance-style-box" >
                            
                                    <span className="dance-style-box__name">Bachata solo</span>
                                </a>
                        </div>
                        </div>
                    </div>
                    <div className="courseMore">
                  
                            <a target="_blank"  href="http://egurrola.com/style-taneczne/" className="courseMore_link" >
                            
                            <CustomButtons clickFunction={()=>{}} classButton="solid" size="big">
                    Zobacz pełną ofertę
                            </CustomButtons>
                        </a>

                    </div>
                </div>
            </main>
        </div>
    );
};

export default Courses;
